/**
 * LagKing TV is a big-screen page; a phone is the controller, never the
 * display (Cole, 2026-09-25: "detect you're on a phone and not serve it from
 * mobile"). Pure so Node tests can import it.
 *
 * Phones: iPhone/iPod, or Android with "Mobile". TV and streaming-device
 * browsers (Tizen, webOS, Fire TV, Google TV, Chromecast, generic SMART-TV)
 * are never phones, even when they report Android. Tablets pass: an iPad or
 * Android tablet can stand in as a display. `?allowPhone` overrides, for
 * testing.
 */
const TV_MARKERS = /smart-?tv|tizen|web0s|webos|netcast|\baft[a-z]{0,4}\b|android tv|googletv|google tv|crkey|bravia|hbbtv|roku/i;

export function isPhoneBrowser(userAgent: string, search = ''): boolean {
  if (/[?&]allowPhone\b/.test(search)) return false;
  if (TV_MARKERS.test(userAgent)) return false;
  if (/iphone|ipod/i.test(userAgent)) return true;
  if (/android/i.test(userAgent) && /mobile/i.test(userAgent)) return true;
  if (/windows phone|blackberry|iemobile/i.test(userAgent)) return true;
  return false;
}
